import {createTheme, ThemeProvider} from '@mui/material';
import {ruRU} from '@mui/material/locale';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {RecoilRoot} from 'recoil';

import App from './App';
import {ErrorToastLayer} from './ui/error-layer';

import 'react-photo-view/dist/react-photo-view.css';
import './styles/global.scss';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

const theme = createTheme({}, ruRU);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <ToastContainer containerId="default" />
        <ErrorToastLayer />
        <App />
      </RecoilRoot>
    </ThemeProvider>
  </React.StrictMode>,
);
